
const token = getURLParameter("token");

$(document).ready(function () {

    // Only for Proposal Booking Page
    if (!$('#interpreter_propose_booking_page').length) return false;

    if (token === null) {
        displayUnauthorizedPage();
        return;
    }

    // Retrieve related booking and check if all checksum validations are OK
    retrieveBookingForProposal(token);

    $("#btnTogglePropose").on("click", function () {
        const $container = $("#proposeContainer");
        $container.slideToggle(200, function () {
          if ($container.is(":visible")) {
            $("#proposalText").focus();
          }
        });
    });

    $('#btnAccept').on("click", acceptProposal);
    $('#btnDecline').on("click", declineProposal);
    $('#btnSubmitProposal').on("click", changeProposal);

    function acceptProposal() {
        if (!confirm("Are you sure you want to accept this booking proposition?")) {
            return;
        }
        callApiAfterAnswer("accept", $(this));
    }

    function declineProposal() {
        if (!confirm("Are you sure you want to decline this booking proposition?")) {
            return;
        }
        callApiAfterAnswer("decline", $(this));
    }

    function changeProposal() {
        const proposalNotes = $("#proposalText").val().trim();
        if (!proposalNotes) {
            alert("Please enter your available dates and times before submitting.");
            $("#proposalText").focus();
            return;
        }
        callApiAfterAnswer("propose", $(this), proposalNotes);
    }

    function callApiAfterAnswer(state, $btn, comment = null) {
        $.ajax({
            url: getApiURL("interpreters/report/proposal"),
            type: "POST",
            dataType: 'json',
            data: {
                token: token,
                action: state,
                comment: comment
            },
            beforeSend: function() {
                $btn.prop("disabled", true);
                switch (state) {
                    case "accept": $btn.text("Accepting...");break;
                    case "decline": $btn.text("Declining...");break;
                    case "propose": $btn.text("Submitting...");break;
                }
            },
            success: function() {
                switch (state) {
                    case "accept": showResultScreen("accepted", "Availability Received", "Thank you. You have confirmed your availability for this job.<br>Please note that the booking is not yet finalized. <br>You will receive a confirmation email once the job has been officially allocated to you.");break;
                    case "decline": showResultScreen("declined", "Booking Declined", "You have declined this job proposition.");break;
                    case "propose": showResultScreen("proposed", "Alternative Availability Submitted", "Thank you! Your proposed availability has been sent to our scheduling team for review.");break;
                }
            },
            error: function (xhr, status, error) {
                console.error("Submission failed", error);
                alert("Failed to submit the proposal. Please try again.");
            },
            complete: function() {
                $btn.prop("disabled", false);
                switch (state) {
                    case "accept": $btn.text("YES, I ACCEPT");break;
                    case "decline": $btn.text("NO, I DECLINE");break;
                    case "propose": $btn.text("PROPOSE OTHER AVAILABILITY");break;
                }
            }
        });
    }

    function showResultScreen(type, title, message) {
        $("#actionContainer").slideUp(300, function () {
          const $icon = $("#resultIcon");
          $icon.removeClass("accepted declined proposed").addClass(type);
          
          if (type === "accepted") $icon.text("✓");
          else if (type === "declined") $icon.text("✕");
          else $icon.text("✉");

          $("#resultTitle").text(title);
          $("#resultMessage").html(message);
          $("#resultPanel").fadeIn(300);
        });
    }

    function formatProposalAnswser(answer) {
        if (answer === "interested") return "You are Interested.";
        if (answer === "not interested") return "You are Not Interested.";
        return "";
    }

    function retrieveBookingForProposal(token) {
        $.ajax({
            type: "GET",
            url: getApiURL("interpreters/report/proposal/") + token,
            success: function (data) {
                displayProposalForm(data);
                return data;
            },
            error: function (request) {
                switch (request.status) {
                    case 401: displayAlreadyReported(ATLAlerts.formatAPIException(request)); break;
                    case 404: displayNotFound(ATLAlerts.formatAPIException(request)); break;
                    case 500: displayTechnical(); break;
                    default: displayUnauthorizedPage();
                }
                return null;
            }
        });
    }

    function displayProposalForm(data) {
        $("[data-booking]").text(data.ref);
        if (data.timezone !== null) {
            $("[data-time]").text(`${data.date} (${data.timezone})`);
        } else {
            $("[data-time]").text(data.date);
        }
        $("[data-duration]").text(data.duration);
        $("[data-language]").html(`<span class="badge">${data.language}</span>`);
        $("[data-job]").text(data.job_type);
        $("[data-jobcode]").text(data.job_code);
        if (data.location == "") {
            $("[data-location-block]").hide();
        } else {
            $("[data-location]").text(data.location);
        }
        $("#actionContainer").show();

        // Manage if already answered
        if (data.already_answered) {
            $("#disclaimer-box .disclaimer-text").html(`You already have answered to this proposal. <br><strong>${formatProposalAnswser(data.answer)}</strong><br><br>If you want to change your mind, please use the form below.`);
            $("#disclaimer-box").show();
            $("#standardActionGroup").hide();
            $("#proposeContainer").show();
        }
    }
});

